module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pharmacy/pharmacy.component.scss
// module id = ./src/app/pharmacy/pharmacy.component.scss
// module chunks = main